import React from 'react'
import SuplierForm from '../../components/Supliers/suplierForm/SupliersForm'
import SuppliersList from '../../components/Supliers/SuplierList/SupliersList'


function Suppliers() {
  return (
    <div>
        <SuplierForm/>
        <SuppliersList/>
    </div>
  )
}

export default Suppliers